import { createGlobalStyle } from 'styled-components';

const _b = '#333147';

const AllStyles = createGlobalStyle`



*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

body{
    background: ${_b};
    font-family: 'MarkPro-Book';
    color: #fff;
    overflow-x: hidden;
}

b{
    font-family: 'MarkPro-Bold';
}

.small-bold{
    font-size: 24px !important;
    font-family: 'MarkPro-Bold' !important;

    
}

.App{
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;

    @media (max-width: 1060px) {
        height: auto;
        overflow-y: auto;
        overflow-x: hidden;
    }
}

.blue-icon{
    color: #333147;
    fill: #333147;
}

.half{
    .question-title{
        font-size: 2em;
        font-family: 'MarkPro-Light';
        line-height: 1;
        margin-bottom: 10px;
    }
    
}

.determined-benchmark{
    color: #333147;
    font-family: 'MarkPro-Black';
    font-size: 1.8em;

    span{
        font-family: 'MarkPro-Black';
        font-size: 1.6em;
    }
}

.injected{
    padding-bottom: 30px;
}

.main-q{
    font-size: 3em;
    font-family: 'MarkPro-Black';

    @media (max-width: 1060px) {
        margin-top: 50px;
        width: 100%;
        max-width: 100%;
    }

}

.turq{
    .main-q{
        color: #8085c0;
        /* max-width: 60%; */
        margin-bottom: 30px;
    }

    .determined-benchmark{
        span{
            color: #8085c0;
        }
    }


    > div{
        &::after{
            background: rgba(131,141,200,.5);
        }
    }
}


.coral{
    .main-q{
        color: #D5665F;
        /* max-width: 60%; */
        margin-bottom: 30px;
    }

    .determined-benchmark{
        span{
            color: #D5665F;
        }
    }


    > div{
        &::after{
            background: rgba(242,102,95,.5);
        }
    }
}


.yellow{
    .main-q{
        color:#EAB330;
        /* max-width: 60%; */
        margin-bottom: 30px;
    }

    .determined-benchmark{
        span{
            color: #EAB330;
        }
    }


    > div{
        &::after{
            background: rgba(253,181,21,.5);
        }
    }
}


.violet{
    .main-q{
        color: #654EA3;
        /* max-width: 60%; */
        margin-bottom: 30px;
    }

    .determined-benchmark{
        span{
            color: #654EA3;
        }
    }


    > div{
        &::after{
            background: rgba(101,78,163,.5);
        }
    }
}





.pink{
    .main-q{
        color: #CA0088;
        max-width: 60%;
        margin-bottom: 30px;
    }

    .determined-benchmark{
        span{
            color: #CA0088;
        }
    }
}

.question-title{
    font-family: 'MarkPro-Black';
    font-size: 1.8em;
}

.default-slider{
    -webkit-appearance: none;
  width: 84%;
  height: 15px;
  border-radius: 5px;  
  background: #d3d3d3;
  outline: none;
  opacity: 1;
  -webkit-transition: .2s;
  transition: opacity .2s;

  &.seconds{
      width: 70%;
  }

  @media (max-width: 1060px) {
       width: 100% !important;
    }

}

.default-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%; 
  background: #333147;
  cursor: pointer;
}

.default-slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #333147;
  cursor: pointer;
}

`

export default AllStyles; 